<template>
    <div class="alert-system__container">
        <v-alert :type="alert.type" :icon="getIcon(alert.type)" :color="getColor(alert.type)" class="alert-sistema">
            <span style="flex:1;" class="text-start" v-if="!alert.transformInHtml">{{ alert.message }} </span>
            <span style="flex:1;" class="text-start" v-else v-html="alert.message"></span>
            <div>
                <v-btn icon @click="togglePause" v-if="!alert.startPaused">
                    <v-icon class="icon">{{ paused ? 'mdi-play' : 'mdi-pause' }}</v-icon>
                </v-btn>
                <v-btn icon @click="closeAlert">
                    <v-icon class="icon">mdi-close</v-icon>
                </v-btn>
            </div>
            <v-progress-linear
                    :value="progressValue"
                    v-if="!paused"
                    absolute
                    bottom
                    color="white"
            ></v-progress-linear>
        </v-alert>
    </div>
</template>

  <script>
  const colorMap = {
    success: 'success',
    error: 'error',
    warning: 'warning',
    info: 'info'
  }

  const iconMap = {
    success: 'mdi-check-circle',
    error: 'mdi-alert-octagon-outline',
    warning: 'warning',
    info: 'info'
  }

  export default {
    name: 'Alert',
    props: {
      alert: Object,
      firstIndexNotPaused: Number,
      index: Number,
      tempoAlertasVariados: Number,
      tempoAlertasErro: Number
    },
    data () {
      return {
        paused: this.alert.startPaused || false,
        timer: null,
        progressValue: 100,
        timeLeft: null
      }
    },
    computed: {
      isTheFirst () {
        return this.firstIndexNotPaused === this.index
      }
    },
    watch: {
      paused (newVal) {
        if (newVal) {
          clearTimeout(this.timer)
        } else {
          this.startTimer()
        }
      },
      firstIndexNotPaused (value) {
        if (value === this.index && !this.paused) {
          this.startTimer()
        }
      }
    },
    mounted () {
      if (this.isTheFirst) {
        if (this.alert.startPaused) {
          this.paused = false
          this.togglePause()
          return
        }
        this.startTimer()
      }
      if (this.alert.paused) {
        this.paused = true
      }
    },
    beforeDestroy () {
      clearTimeout(this.timer)
    },
    methods: {
      closeAlert () {
        this.$emit('close', this.index)
      },
      togglePause () {
        this.paused = !this.paused
        this.$emit('pause', this.index)
      },
      getColor (type) {
        return colorMap[type]
      },
      getIcon (type) {
        return this.alert.icon || iconMap[type]
      },
      startTimer () {
        const timeout = this.alert.type === 'error' ? this.tempoAlertasErro : this.tempoAlertasVariados
        this.timeLeft = timeout
        this.timer = setInterval(() => {
          this.timeLeft -= 150
          this.progressValue = (this.timeLeft / timeout) * 100

          if (this.timeLeft <= 0) {
            clearInterval(this.timer)
            this.closeAlert()
          }
        }, 150)
      },
      getProgressColor (type) {
        return type === 'error' ? 'error' : 'primary'
      }
    }
  }
  </script>

<style>
  .alert-system__container{
    width: auto;
    z-index: 9999998;
  }
  .alert-sistema{
    width: fit-content;
    word-break: break-word;
  }

  .alert-sistema div{
    display: flex;
    align-items: center;
  }

  .alert-sistema div i {
    align-self: center;
  }

  .alert-sistema div .v-alert__content {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    text-align: center;
    white-space:normal;
    line-break: loose;
  }

</style>
